if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();

      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.bindConsentControls();
        if (window.Shopify.customerPrivacy) {
          this.onConsentLibraryLoaded();
          return;
        }
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1'
        }], this.onConsentLibraryLoaded.bind(this));
      }
    
      hasConsentChoice() {
        const consent = window.Shopify.customerPrivacy?.currentVisitorConsent?.();
        return ['analytics', 'marketing', 'preferences'].every((purpose) =>
          consent?.[purpose] === 'yes' || consent?.[purpose] === 'no'
        );
      }

      shouldDisplayBanner() {
        return !this.hasConsentChoice() &&
          (this.testMode || window.Shopify.customerPrivacy?.shouldShowBanner());
      }

      load(delay) {
        clearTimeout(this.showTimer);
        if (Shopify.designMode || !this.shouldDisplayBanner()) return;
        this.showTimer = setTimeout(() => {
          if (this.isConnected && this.shouldDisplayBanner()) this.show();
        }, delay * 1000);
      }

      bindConsentControls() {
        if (this.controlsBound) return;
        this.controlsBound = true;
        if (this.acceptButton) this.on(this.acceptButton, 'click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.on(this.declineButton, 'click', this.declinePolicy.bind(this));
        const saveButton = this.querySelector('button[name="save"]');
        const details = this.querySelector('.cookie__preferences');
        if (saveButton) this.on(saveButton, 'click', () => {
          const choice = {};
          this.querySelectorAll('input[data-cookie-purpose]').forEach((input) => {
            choice[input.dataset.cookiePurpose] = input.checked;
          });
          this.saveConsent(choice);
        });
        if (details) this.on(details, 'toggle', () => {
          if (!details.open) return;
          const consent = window.Shopify.customerPrivacy?.currentVisitorConsent();
          this.querySelectorAll('input[data-cookie-purpose]').forEach((input) => {
            input.checked = consent?.[input.dataset.cookiePurpose] === 'yes';
          });
        });
        this.openPreferences = (event) => {
          const link = event.target.closest?.('a[href="#shopifyReshowConsentBanner"]');
          if (!link) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showCookiePreferences();
        };
        window.addEventListener('click', this.openPreferences, true);
        this.consentChanged = () => {
          if (!this.hasConsentChoice()) return;
          clearTimeout(this.showTimer);
          this.hide();
        };
        document.addEventListener('visitorConsentCollected', this.consentChanged);
      }
    
      onButtonClick(event) {
        if (event.currentTarget?.hasAttribute('data-cookie-preferences')) {
          event.preventDefault();
          this.showCookiePreferences();
          return;
        }
        super.onButtonClick(event);
      }

      acceptPolicy() {
        this.saveConsent(true);
      }

      declinePolicy() {
        this.saveConsent(false);
      }

      showCookiePreferences() {
        this.show();
        const details = this.querySelector('.cookie__preferences');
        if (details) details.open = true;
      }

      saveConsent(accepted) {
        const privacy = window.Shopify.customerPrivacy;
        if (!privacy?.setTrackingConsent) return;
        const choice = typeof accepted === 'object' ? accepted : {
          analytics: accepted,
          marketing: accepted,
          preferences: accepted
        };
        clearTimeout(this.showTimer);
        privacy.setTrackingConsent(choice, (result) => {
          if (result?.error) {
            console.warn('Cookie consent could not be saved.', result.error);
            return;
          }
          if (!this.hasConsentChoice()) {
            console.warn('Cookie consent was not confirmed by Shopify.');
            return;
          }
          this.hide();
        });
      }

      onConsentLibraryLoaded(error) {
        if (error || !window.Shopify.customerPrivacy) return;
        this.bindConsentControls();
        this.load(this.delay);
      }

      connectedCallback() {
        super.connectedCallback?.();
        this.init();
      }

      disconnectedCallback() {
        clearTimeout(this.showTimer);
        window.removeEventListener('click', this.openPreferences, true);
        document.removeEventListener('visitorConsentCollected', this.consentChanged);
        this.controlsBound = false;
        this.initialized = false;
        super.disconnectedCallback?.();
      }

      showTransition() {
        this.setAttribute('active', '');
        return Promise.resolve();
      }

      hideTransition() {
        this.removeAttribute('active');
        return Promise.resolve();
      }

      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}

